(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["on-stores"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Loop through all swiper containers
  document.querySelectorAll(".region-swiper").forEach(function (el) {
    new Swiper(el, {
      slidesPerView: 6.5,
      spaceBetween: 16,
        breakpoints: {
        200: {
          spaceBetween: 8,
          slidesPerView: 3.5,
        },
        767: {
            slidesPerView: 6.5,
            spaceBetween: 16,
        },
      }
    });
  });
});
// REPLACE this block in your {% javascript %}
document.addEventListener("DOMContentLoaded", function () {
  const floatingWrapper = document.querySelector(".floting-wrapper");
  const firstSwiper = document.querySelector(".on-stores .region-swiper");
  const storesSection = document.querySelector(".on-stores"); // ADD THIS

  let lastScrollY = window.scrollY;

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function isBelowSection(el) {                          // ADD THIS
    return el.getBoundingClientRect().bottom < 0;        // section fully above viewport
  }

  window.addEventListener("scroll", function () {
    let currentScrollY = window.scrollY;

    if (isInViewport(firstSwiper)) {
      // Section is visible → always hide
      floatingWrapper.classList.remove("active");
    } else if (!isBelowSection(storesSection)) {
      // User is ABOVE the section → never show floater
      floatingWrapper.classList.remove("active");
    } else {
      // User is below the section → scroll up shows, scroll down hides
      if (currentScrollY < lastScrollY) {
        floatingWrapper.classList.add("active");
      } else {
        floatingWrapper.classList.remove("active");
      }
    }

    lastScrollY = currentScrollY;
  });
});
document.addEventListener("DOMContentLoaded", function () {
  // Select all slides inside both swipers
  const allStoreBlocks = document.querySelectorAll(".region-swiper .swiper-slide .stores-block");
  allStoreBlocks.forEach(slide => {
    slide.addEventListener("click", function () {

      allStoreBlocks.forEach(inner => {
        inner.classList.remove('active');
      });

      const targetHref = this.getAttribute("href");
      const matchedEl = document.querySelectorAll(`[href="${targetHref}"]`);
      console.log(matchedEl, 'matcehd elllll');
                if (matchedEl.length) {
            matchedEl.forEach((el, i) => {
                el.classList.add('active');
            });
          }
      if (!targetHref) return;

      const targetId = targetHref.replace("#", "");
      const targetEl = document.getElementById(targetId);

      if (targetEl) {
        window.scrollTo({
          top: targetEl.offsetTop,
          behavior: "smooth"
        });
      }
    });
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stores-region"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".store-regions-blocks-wrapper accordion-element > span");

  accordions.forEach(header => {
    header.addEventListener("click", function () {
      const hash = this.dataset.hash; // e.g. "hong-kong"

      // Push hash into URL without scrolling
      if (hash) {
        history.pushState(null, "", `#${hash}`);
      }
    });
  });

  // On page load → open accordion if URL has hash
  const initHash = window.location.hash.replace("#", "");
  if (initHash) {
    const header = document.querySelector(`.store-regions-blocks-wrapper accordion-element > span[data-hash="${initHash}"]`);
    if (header) {
      header.setAttribute("aria-expanded", "true");
      if (header.nextElementSibling) {
        header.nextElementSibling.style.height = "auto";
      }
      header.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
});




  } catch(e) { console.error(e); }
})();
})();
